import { combineReducers } from 'redux';
import list from './list';
import show from './show';
import waitinglist from './waitinglist';

export default combineReducers({ list, show, waitinglist });
